import { render, staticRenderFns } from "./mainRoute.vue?vue&type=template&id=4b0709e1&"
import script from "./mainRoute.vue?vue&type=script&setup=true&lang=js&"
export * from "./mainRoute.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports